<li
  #element
  [id]="id"
  role="menuitem"
  [tabindex]="tabindex"
  (click)="selected.emit()"
  (mouseover)="handleMouseover($event)"
  (keydown)="handleKeydown($event)"
  (focusout)="handleFocusout($event)"
>
  <ng-content></ng-content>

  <div *ngIf="hasSubmenu" class="submenu-icon">
    <opac-icon icon="navigate_next"></opac-icon>
  </div>
</li>
